<nav id="mainNavigation" class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <button class="navbar-toggler" type="button" routerLink="/navigation" >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
        <ul class="navbar-nav">
          <li class="nav-item">
            <div class="btn-group" dropdown>
              <button id="button-basic" dropdownToggle type="button" class="btn dropdown-toggle"
                      aria-controls="dropdown-basic"  >Search<span class="caret"></span>
              </button>
              <ul id="searchMenuList" *dropdownMenu class="dropdown-menu"
                  role="menu" aria-labelledby="button-basic">
                <li role="menuitem"><a class="dropdown-item" routerLink="/helena" >Tankmix for foliar application</a></li>
                <li role="menuitem"><a class="dropdown-item" routerLink="/helena/helena-search-seed-treatment" >Seed Coatings Tankmix</a></li>
                <div class="dropdown-divider"></div>
                <li role="menuitem"><a class="dropdown-item" routerLink="/helena/search-history" >Search History</a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <div class="btn-group" dropdown>
              <button id="button-basic" dropdownToggle type="button" class="btn dropdown-toggle"
                      aria-controls="dropdown-basic"  >Request<span class="caret"></span>
              </button>
              <ul id="requestMenuList" *dropdownMenu class="dropdown-menu"
                  role="menu" aria-labelledby="button-basic">
                <li role="menuitem"><a class="dropdown-item" routerLink="/helena/request" >Foliar Tankmix</a></li>
                <li role="menuitem"><a class="dropdown-item" routerLink="/helena/helena-request-seed-treatment" >Seed Coatings Tankmix</a></li>
              
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <div class="btn-group" dropdown>
              <button id="button-basic" dropdownToggle type="button" class="btn dropdown-toggle"
                      aria-controls="dropdown-basic"  >Advice<span class="caret"></span>
              </button>
              <ul id="adviceMenuList" *dropdownMenu class="dropdown-menu"
                  role="menu" aria-labelledby="button-basic">
                <li role="menuitem"><a class="dropdown-item" routerLink="/helena/advice/On Mixing Ele-Max" >On mixing</a></li>
                 
              </ul>
            </div>
          </li>
          
        </ul>
        
      </div>
    </div>
  </nav>
